(function () {
  'use strict';

  angular.module('pages.userProfile.userData.editUserModal').component('editUserModalComponent', {
    templateUrl:
      'pages/user-profile/pages/user-data/components/edit-user-modal/edit-user-modal.template.html',
    controller: EditUserModalController,
    controllerAs: 'vm',
  });

  function EditUserModalController($scope, AnalyticsService, GlobalService, UserService) {
    var vm = this;

    vm.busy = false;

    // Variable para dejar de escuchar los cambios en el rootScope
    var unregisterOpenEditUserModal;

    // Input del usuario
    vm.name = '';
    vm.lastname = '';
    vm.fecha_nacimiento = '';
    vm.phone_number = '';

    // Variables enlazadas a la plantilla
    vm.editUserError = false;
    vm.fecha_nacimiento_blocked = false;

    // Funciones enlazadas a la plantilla
    vm.$onInit = onInit;
    vm.closeEditUserModal = closeEditUserModal;
    vm.editUser = editUser;

    function onInit() {
      unregisterOpenEditUserModal = $scope.$on('openEditUserModal', function () {
        var user = GlobalService.user;

        vm.name = user.name;
        vm.lastname = user.lastname;
        vm.fecha_nacimiento = user.fecha_nacimiento;
        vm.phone_number = user.phone_number;
        vm.editUserError = false;
        vm.maxBirthdate = new Date().toISOString().split('T')[0];
        vm.fecha_nacimiento_blocked = !!user.fecha_nacimiento;
        $scope.form.$setPristine();
        $scope.form.$setUntouched();
        $('#edit-user-modal-component').modal('show');
        AnalyticsService.initEditProfile();
      });
    }

    function closeEditUserModal() {
      $('#edit-user-modal-component').modal('hide');
    }

    function editUser() {
      vm.busy = true;
      vm.editUserError = false;

      var user = {
        email: GlobalService.user.email,
        name: vm.name,
        lastname: vm.lastname,
        fecha_nacimiento: formatFechaToDDMMYYYY(vm.fecha_nacimiento),
        phone_number: vm.phone_number,
      };

      UserService.updateUserData(user).then(
        function (value) {
          var user = value.data;

          vm.busy = false;

          GlobalService.user.name = user.name;
          GlobalService.user.lastname = user.lastname;
          GlobalService.user.fecha_nacimiento = user.fecha_nacimiento;
          GlobalService.user.email = user.email;
          GlobalService.user.phone_number = user.phone_number;

          vm.closeEditUserModal();

          $scope.$emit('userEdited');
          AnalyticsService.editProfile();
        },
        function () {
          vm.busy = false;
          vm.editUserError = true;
        }
      );
    }

    $scope.$on('$destroy', function () {
      unregisterOpenEditUserModal();
    });

    // Validador personalizado para evitar fechas futuras
    $scope.$watch(function () {
      return vm.fecha_nacimiento;
    }, function (newVal) {
      if ($scope.form && $scope.form.fecha_nacimiento) {
        $scope.form.fecha_nacimiento.$setValidity('future', !isFutureDate(newVal));
      }
    });

    function isFutureDate(fecha) {
      if (!fecha) return false;
      let inputDate;
      // dd-MM-yyyy
      if (/^\d{2}-\d{2}-\d{4}$/.test(fecha)) {
        const parts = fecha.split('-');
        inputDate = new Date(parts[2], parts[1] - 1, parts[0]);
      }
      // yyyy-MM-dd
      else if (/^\d{4}-\d{2}-\d{2}$/.test(fecha)) {
        const parts = fecha.split('-');
        inputDate = new Date(parts[0], parts[1] - 1, parts[2]);
      } else {
        return false;
      }
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return inputDate > today;
    }

    // Formatea una fecha yyyy-MM-dd a dd-MM-yyyy
    function formatFechaToDDMMYYYY(fecha) {
      if (!fecha) return '';
      if (/^\d{2}-\d{2}-\d{4}$/.test(fecha)) return fecha;
      var parts = fecha.split('-');
      if (parts.length === 3) {
        return parts[2] + '-' + parts[1] + '-' + parts[0];
      }
      return fecha;
    }
  }
})();
